import { Link } from 'react-router-dom'
import { PAGE_CONFIG } from 'utils/constants'

const ConfigBackLink = () => {
  return (
    <Link
      to={PAGE_CONFIG.path}
      className="mb-2 inline-flex items-center gap-1 text-sm font-medium text-gray-500 hover:text-gray-800"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="h-4 w-4"
        fill="none"
        viewBox="0 0 24 24"
        stroke="currentColor"
        strokeWidth={2}
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M15.75 19.5L8.25 12l7.5-7.5"
        />
      </svg>
      Back to Configurations
    </Link>
  )
}

export default ConfigBackLink
